Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Video = void 0;

var react_1 = require("react");

var core_1 = require("@emotion/core");

var styled_system_1 = require("@wheelroom/styled-system");

var merge_ncss_1 = require("../lib/merge-ncss");

var video_reset_1 = require("./video-reset");

var defaultMediaGatsbyModel = {
  description: 'No media description available',
  file: {
    url: 'https://www.example.com',
    fileName: 'none',
    contentType: 'video/mp4'
  },
  title: 'No media title available'
};

exports.Video = function (props) {
  var _a, _b, _c;

  var media = props.media || defaultMediaGatsbyModel;

  if (((_a = media === null || media === void 0 ? void 0 : media.file) === null || _a === void 0 ? void 0 : _a.contentType) === 'image/jpeg' || ((_b = media === null || media === void 0 ? void 0 : media.file) === null || _b === void 0 ? void 0 : _b.contentType) === 'image/webp' || ((_c = media === null || media === void 0 ? void 0 : media.file) === null || _c === void 0 ? void 0 : _c.contentType) === 'image/png') {
    return null;
  }

  var videoAttrs = {
    poster: props.poster || '',
    title: media.title || props.title || defaultMediaGatsbyModel.title,
    url: media.file && media.file.url || defaultMediaGatsbyModel.file.url,
    type: media.file && media.file.contentType || defaultMediaGatsbyModel.file.contentType,
    description: media.description || props.description || defaultMediaGatsbyModel.description
  };
  var videoLabel = {
    ncss: {
      label: 'video'
    }
  };
  var descriptionLabel = {
    ncss: {
      label: 'video-description'
    }
  };
  return core_1.jsx(react_1.Fragment, null, core_1.jsx("video", {
    poster: videoAttrs.poster && videoAttrs.poster + '?q=75',
    css: styled_system_1.styledSystem(props.wheel.wrSystemConfig, props.wheel.wrSystemTheme, merge_ncss_1.mergeNcss([videoLabel, video_reset_1.videoVideoElementStyle, props.wheel.elementNcss.video, props.wheel.style])),
    controls: true,
    playsInline: true
  }, core_1.jsx("source", {
    src: videoAttrs.url,
    type: videoAttrs.type
  }), "Your browser does not support the video tag."), props.includeTitle && core_1.jsx("p", {
    css: styled_system_1.styledSystem(props.wheel.wrSystemConfig, props.wheel.wrSystemTheme, merge_ncss_1.mergeNcss([descriptionLabel, video_reset_1.videoDescriptionReset, props.wheel.elementNcss.video.description, props.wheel.style.description]))
  }, core_1.jsx("b", null, videoAttrs.title), props.includeDescription && " \u2013 " + videoAttrs.description));
};